'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactCssModules = require('react-css-modules');

var _reactCssModules2 = _interopRequireDefault(_reactCssModules);

var _PlanScorecardCompanyLetter = require('./PlanScorecardCompanyLetter.css');

var _PlanScorecardCompanyLetter2 = _interopRequireDefault(_PlanScorecardCompanyLetter);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AndrewBeharSignature = (_dec = (0, _reactCssModules2.default)(_PlanScorecardCompanyLetter2.default), _dec(_class = function (_Component) {
  (0, _inherits3.default)(AndrewBeharSignature, _Component);

  function AndrewBeharSignature() {
    (0, _classCallCheck3.default)(this, AndrewBeharSignature);
    return (0, _possibleConstructorReturn3.default)(this, (AndrewBeharSignature.__proto__ || (0, _getPrototypeOf2.default)(AndrewBeharSignature)).apply(this, arguments));
  }

  (0, _createClass3.default)(AndrewBeharSignature, [{
    key: 'render',
    value: function render() {
      var andrewBeharSignature = require('../../../static/images/andrew-behar-signature.png');
      //
      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'p',
          null,
          'Sincerely,'
        ),
        _react2.default.createElement('img', {
          src: andrewBeharSignature,
          alt: 'Andrew Behar',
          styleName: 'signature-image'
        }),
        _react2.default.createElement(
          'p',
          null,
          _react2.default.createElement(
            'b',
            null,
            'Andrew Behar',
            _react2.default.createElement('br', null),
            'CEO, As You Sow'
          )
        )
      );
    }
  }]);
  return AndrewBeharSignature;
}(_react.Component)) || _class);
exports.default = AndrewBeharSignature;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/PlanScorecardCompanyLetter/AndrewBeharSignature.js
// module id = 1396
// module chunks = 0